export enum ActivityType {
  EMAIL = "EMAIL",
  MEETING = "MEETING",
  SUPPORT_TICKET = "SUPPORT_TICKET",
  NOTE = "NOTE",
}
export enum ActivityTypeLabel {
  EMAIL = "Email",
  MEETING = "Meeting",
  SUPPORT_TICKET = "Support Ticket",
  NOTE = "Note",
}

/**
 * Activity Status
 * Controls the two-phase lifecycle for calendar-sourced activities.
 * - UPCOMING: event hasn't occurred yet (hidden from activity feed, shown in upcoming widget)
 * - COMPLETED: event has passed or was manually COMPLETED (shown in activity feed)
 * Default is 'COMPLETED' so existing activities are unaffected.
 */
export enum ActivityStatus {
  UPCOMING = "UPCOMING",
  COMPLETED = "COMPLETED",
}

/**
 * Activity Source
 * Tracks where an activity originated from.
 */
export enum ActivitySource {
  MANUAL = "MANUAL",
  GONG = "GONG",
  GOOGLE_CALENDAR = "GOOGLE_CALENDAR",
  FATHOM = "FATHOM",
}
